import { queryOptions, useQuery } from '@tanstack/react-query';

import { blogApi } from '../api/blog-api';

import { blogKeys } from './blog-keys';

/** The whole bounded list, in position order. */
export function blogCategoriesQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: blogKeys.categories(storeId),
    queryFn: () => blogApi.listCategories(storeId),
  });
}

export function useBlogCategories(storeId: string) {
  return useQuery(blogCategoriesQueryOptions(storeId));
}
